<template>
  <div
    v-if="offerThresholdList.length"
    class="cf-flex cf-flex--column cf-flex--gap-16 loyalty-tab__list"
  >
    <conversion-threshold-card
      v-for="threshold in offerThresholdList"
      :key="threshold.publicId"
      :threshold="threshold"
      :is-offer-disabled="isOfferDisabled"
      @set-selected-tab="setTabSelection"
    />
  </div>

  <empty-state-tagline
    v-else
    :banner-content="bannerContent"
  />
</template>


<script>
  import { mapGetters } from 'vuex';

  import ConversionThresholdCard from './conversion-threshold-card/index.vue';

  import EmptyStateTagline from '../empty-state-tagline/index.vue';


  export default {
    name: 'LoyaltyConversionThresholds',

    components: {
      ConversionThresholdCard,
      EmptyStateTagline
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant', 'loyaltyOptions']),
      ...mapGetters('offers', ['loyalty']),

      offerThresholdList() {
        return this.merchant.options.loyaltyOptions.loyaltyShowLockedRewardsEnabled
          ? this.loyalty.allThresholds
          : this.loyalty.unlockedThresholds;
      },

      isOfferDisabled() {
        return this.loyaltyOptions.isStoreSpecificLoyalty;
      },

      bannerContent() {
        return {
          title: this.content.Loyalty.metadata.rewardStoreEmptyStateTagline,
          message: this.content.Loyalty.metadata.rewardStoreEmptyStateMessage
        };
      }
    },

    methods: {
      setTabSelection() {
        this.$emit('set-selected-tab', 'REWARDS');
      }
    }
  };
</script>


<style lang="sass" scoped>
.loyalty-tab__list
  max-height: 60vh
  overflow-y: auto

  > :deep(*)
    flex-shrink: 0
</style>
